module.exports = __webpack_public_path__ + "img/icon-chevron-left-calendar.e4d35398.svg";